module.exports = require('./helpers/bundle-url').getBundleURL('6XBEJ') + "logo-dark.eefe0b7f.svg";